export class CustomParamsMessageStattracUserModel {
  CallId: string;
  User: number;
}
